import styled from 'styled-components';
import { Box } from '../../../primitives/Box/Box.es.js';
import '../../../utils/assertions.es.js';
import 'react';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { spacing, radius, themeMode, color } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import Radio from '../Radio.es.js';
import '../RadioPrimitive/RadioPrimitive.es.js';
import '../RadioGroup/RadioGroup.es.js';
import './RadioCard.es.js';
var Control = styled(Radio.Control).withConfig({
  componentId: "droc83-0"
})(function (props) {
  return {
    marginTop: spacing("xxs")(props),
    gridRow: "1/1"
  };
});
var Label = styled(Radio.Label).withConfig({
  componentId: "droc83-1"
})({
  gridRow: "1/1",
  gridColumn: "2/2"
});
var Description = styled(Radio.Description).withConfig({
  componentId: "droc83-2"
})({
  gridRow: "2/2",
  gridColumn: "2/-1"
});
var Addon = styled(Box).withConfig({
  componentId: "droc83-3"
})({
  display: "flex",
  gridRow: "1/1",
  gridColumn: "3/-1"
});
var Content = styled(Box).withConfig({
  componentId: "droc83-4"
})(function (props) {
  return {
    marginTop: spacing("xxs")(props),
    gridRow: "3/3",
    gridColumn: "2/-1"
  };
});
Content.displayName = "RadioCard.Content";
var Card = styled(Radio.Root).withConfig({
  componentId: "droc83-5"
})(function (props) {
  return {
    userSelect: "none",
    display: "grid",
    gridTemplateColumns: "min-content 1fr min-content",
    gridTemplateRows: "min-content min-content 1fr",
    gap: "0px " + spacing("xs")(props),
    gridAutoFlow: "column",
    padding: spacing("md")(props),
    borderRadius: radius("base")(props),
    border: "1px solid " + themeMode({
      dark: color("neutral.700"),
      light: color("neutral.300")
    })(props),
    "&:hover": {
      cursor: "pointer",
      borderColor: "" + themeMode({
        dark: color("neutral.50"),
        light: color("neutral.900")
      })(props)
    },
    '&[data-state="checked"]': {
      outline: "1px solid " + themeMode({
        dark: color("neutral.0"),
        light: color("neutral.1000")
      })(props),
      borderColor: "" + themeMode({
        dark: color("neutral.0"),
        light: color("neutral.1000")
      })(props)
    },
    '&[data-disabled="true"]': {
      opacity: 0.5,
      pointerEvents: "none"
    }
  };
});
export { Addon, Card, Content, Control, Description, Label };